import { getSupabase } from '../../components/supabaseClient';
import { getBackendURL } from '../../components/env';

// List the real column names of an allowlisted patient table (admin-gated
// server-side). Returns an array of column-name strings in ordinal order. We
// attach the current Supabase session JWT as the bearer token. Callers treat a
// throw as "columns unknown" and fall back to the curated field list, so this is
// purely additive and failure-safe.
export async function fetchTableColumns({
  table, schema, backendUrl = getBackendURL(), getClient = getSupabase, fetchImpl = fetch,
}) {
  const client = await getClient();
  const { data } = await client.auth.getSession();
  const token = data && data.session && data.session.access_token;

  const params = new URLSearchParams();
  if (schema) params.set('schema', schema);
  if (table) params.set('table', table);

  const res = await fetchImpl(`${backendUrl}/api/admin/patient-table/columns/?${params.toString()}`, {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(schema ? { 'X-Schema': schema } : {}),
    },
  });

  if (!res.ok) {
    let msg = `Could not list columns (HTTP ${res.status})`;
    try { const j = await res.json(); if (j && j.error) msg = j.error; } catch (e) { /* ignore */ }
    throw new Error(msg);
  }
  const body = await res.json();
  return Array.isArray(body.columns) ? body.columns : [];
}
